export default "__VITE_ASSET__DHn6GA2k__";